import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.authReady$.pipe(
    filter(Boolean),
    take(1),
    switchMap(() => authService.isLoggedIn$.pipe(take(1))),
    map((isLoggedIn) => (isLoggedIn ? true : router.createUrlTree(['/admin/login']))),
  );
};
